import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TextUtilitiesService } from '../../core/services/text-utilities.service';


@Component({
  selector:    'red-paragraph-meter',
  templateUrl: './paragraph-meter.component.html',
  styleUrls:   [ './paragraph-meter.component.scss' ]
})
export class ParagraphMeterComponent {

  private _text:          string;
  private _caretPosition: number;

  public paragraphs:      string[];
  public activeParagraph: string;
  public activeIndex:     number;

  @Input()
  public set text(text: string) {
    this._text      = text;
    this.paragraphs = TextUtilitiesService.splitParagraphs(text);
  }

  @Input() public set caretPosition(position: number) {
    this._caretPosition = position;

    if (!this.paragraphs || !position) return;

    this.activeIndex     = this.getParagraphIndexFromCaret();
    this.activeParagraph = this.paragraphs[this.activeIndex];

    this.selectedParagraph.emit(this.activeParagraph);
  }

  @Input() public maxSize: number;

  @Output() public selectedParagraph: EventEmitter<string>;

  constructor() {
    this.selectedParagraph = new EventEmitter<string>();
    this.paragraphs        = [];
    this.caretPosition     = 0;
  }

  private getParagraphIndexFromCaret(): number {
    let charCount: number = 0,
        index:     number = 0;

    for (let paragraph of this.paragraphs) {
      paragraph += '\n';
      charCount += paragraph.length;
      index     += 1;

      if (charCount >= this._caretPosition) break;
    }

    return index - 1;
  }

}
